import "./Name.css";
import configData from '../../../config.json'
const Name = () => (
  <div className="name">
    <div className="name">{configData.name}</div>
  </div>
);

export default Name;
